module.exports = __webpack_public_path__ + "src/assets/images/accident-management/1800Accident_title.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accident-management/1800Accident_title.png
// module id = 2308
// module chunks = 4